export default __webpack_public_path__ + "static/media/ScreenShot_3.99a1e20a.jpg";